<template>
  <form-wrapper :title="option.title"
                :description="option.description"
                @submit="submit()"
                @previous="previous()"
                :isFirst="isFirst"
                :isLast="isLast">

    <b-form-group label="Find Existing Site" label-for="site" label-class="control-label opportunity-form-label required" :class="{ 'invalid-group': $v.form.siteId.$error }">
      <autocomplete ref="siteAutocomplete"
                    :source="sitesApi"
                    v-model="form.siteId"
                    placeholder="Search Sites"
                    :inputClass="{'form-control' : true, 'is-invalid': $v.form.siteId.$error }"
                    resultsValue="siteId"
                    resultsDisplay="name"
                    credentials="include"
                    @clear="clearSite"
                    :request-headers="requestHeaders"
                    @selected="setSiteInfo"></autocomplete>
      <span class="span-feedback invalid-feedback" v-if="$v.form.siteId.$error">You must select a site.</span>
    </b-form-group>

    <div class="text-center">-- OR --</div>

    <b-form-group label="New Site Name"
                  label-class="control-label site-form-label"
                  :class="{ 'invalid-group': $v.form.name.$error }">
      <b-form-input :disabled="!isEditable" v-model="form.name" type="text" :class="{ 'is-invalid': $v.form.name.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.name.$error">You must enter a name.</span>
    </b-form-group>

    <b-form-group label="Street Address"
                  label-class="control-label site-form-label"
                  :class="{ 'invalid-group': $v.form.streetAddress.$error }">
      <b-form-input :disabled="!isEditable" v-model="form.streetAddress" type="text" :class="{ 'is-invalid': $v.form.streetAddress.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.streetAddress.$error">You must enter a street address.</span>
    </b-form-group>

    <b-form-group label="City"
                  label-class="control-label site-form-label"
                  :class="{ 'invalid-group': $v.form.city.$error }">
      <b-form-input :disabled="!isEditable" v-model="form.city" type="text" :class="{ 'is-invalid': $v.form.city.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.city.$error">You must enter a city.</span>
    </b-form-group>

    <b-form-group label="State"
                  label-class="control-label site-form-label"
                  :class="{ 'invalid-group': $v.form.state.$error }">
      <b-form-input :disabled="!isEditable" v-model="form.state" type="text" :class="{ 'is-invalid': $v.form.state.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.state.$error">You must enter a state.</span>
    </b-form-group>

    <b-form-group label="Zip"
                  label-class="control-label site-form-label"
                  :class="{ 'invalid-group': $v.form.zip.$error }">
      <b-form-input :disabled="!isEditable" v-model="form.zip" type="text" :class="{ 'is-invalid': $v.form.zip.$error }"></b-form-input>
      <span class="span-feedback invalid-feedback" v-if="$v.form.zip.$error">You must enter a zip.</span>
    </b-form-group>

    <b-form-group label="Website" label-class="control-label site-form-label">
      <b-form-input :disabled="!isEditable" v-model="form.website" type="text"></b-form-input>
    </b-form-group>

    <b-form-group label="Phone" label-class="control-label site-form-label">
      <b-form-input :disabled="!isEditable" v-model="form.phone" type="text"></b-form-input>
    </b-form-group>         
                
    <template slot="buttons">
      <b-btn variant="primary" type="submit" class="ml-2 pull-right">{{ isLast ? 'Submit' : 'Save and Next'}}</b-btn>
      <b-btn variant="secondary" @click="previous()" class="ml-2 pull-right" v-if="!isFirst">Back</b-btn>
      <b-btn variant="secondary" @click="reset()" class="ml-2 pull-right">Reset</b-btn>
    </template>

  </form-wrapper>
</template>

<script>
import { mapActions, mapState } from "vuex";
import formWrapper from "./form-wrapper";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" },
      originalSiteId: 0,
      form: {
        siteId: 0,
        name: null,
        description: null,
        streetAddress: null,
        city: null,
        state: null,
        zip: null,
        website: null,
        phone: null,
        fax: null
      }
    };
  },

  props: {
    option: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    },
    asuriteId: {
      type: String,
      required: false
    }
  },

  components: {
    "form-wrapper": formWrapper
  },

  validations() {
    if (!this.form.siteId || this.form.siteId == this.originalSiteId) {
      return {
        form: {
          name: {
            required
          },
          streetAddress: {
            required
          },
          city: {
            required
          },
          state: {
            required
          },
          zip: {
            required
          },
          siteId: { required }
        }
      };
    } else {
      return {
        form: {
          name: {},
          streetAddress: {},
          city: {},
          state: {},
          zip: {},
          siteId: {
            required
          }
        }
      };
    }
  },

  computed: {
    ...mapState({
      userId: state => state.auth.user.userId,
      studentOpportunityId: state =>
        state.additionalMaterials.studentOpportunityId,
      studentOpportunity: state => state.additionalMaterials.studentOpportunity
    }),
    sitesApi: function() {
      return process.env.VUE_APP_BASE_URI + "/api/Sites/FindSite?query=";
    },
    isEditable: function() {
      return this.userId == this.form.createdBy || !this.form.createdBy;
    }
  },
  methods: {
    ...mapActions("additionalMaterials", [
      "setStudentOpportunity",
      "setStudentOpportunityId"
    ]),
    ...mapActions("pip", ["createShell", "updateShell"]),
    clearSite: function() {
      this.loadForm(this.studentOpportunity.opportunity.site);
    },
    reset: function() {
      this.loadForm({
        siteId: this.isEditable ? this.originalSiteId : 0,
        name: null,
        description: null,
        streetAddress: null,
        city: null,
        state: null,
        zip: null,
        website: null,
        phone: null,
        fax: null
      });
      this.$refs.siteAutocomplete.display = "";
    },
    setSiteInfo: function(object) {
      //this.studentOpportunity.opportunity.site.siteId = object.selectedObject.siteId

      // this.form.name = object.selectedObject.name;
      // this.form.description = object.selectedObject.description;
      // this.form.streetAddress = object.selectedObject.streetAddress;
      // this.form.city = object.selectedObject.city;
      // this.form.state = object.selectedObject.state;
      // this.form.zip = object.selectedObject.zip;
      // this.form.website = object.selectedObject.website;
      // this.form.phone = object.selectedObject.phone;
      // this.form.fax = object.selectedObject.fax;
      this.loadForm(object.selectedObject);
    },
    submit: function() {
      this.$v.$touch();
      var that = this;

      if (!this.$v.$invalid) {
        this.studentOpportunity.opportunity.site = this.form;
        if (this.studentOpportunity.studentOpportunityId) {
          this.updateShell(this.studentOpportunity).then(response => {
            that.setStudentOpportunity(response.data);
            that.setStudentOpportunityId(
              that.studentOpportunity.studentOpportunityId
            );
            that.originalSiteId = response.data.opportunity.siteId;
            that.$emit("submitted");
          });
        } else {
          this.createShell(this.studentOpportunity).then(response => {
            that.setStudentOpportunity(response.data);
            that.setStudentOpportunityId(
              that.studentOpportunity.studentOpportunityId
            );
            that.originalSiteId = response.data.opportunity.siteId;
            that.$emit("submitted");
          });
        }
      }
    },
    previous: function() {
      this.$emit("previous");
    },
    loadForm(item) {
      if (item) {
        this.form = _.clone(item);
      }
    }
  },

  watch: {
    studentOpportunity: function() {
      if (this.studentOpportunity.opportunity.site) {
        this.loadForm(this.studentOpportunity.opportunity.site);
        this.originalSiteId = this.studentOpportunity.opportunity.site.siteId;
      }
    }
  },

  created() {
    if (this.studentOpportunity.opportunity.site) {
      this.loadForm(this.studentOpportunity.opportunity.site);
      this.originalSiteId = this.studentOpportunity.opportunity.site.siteId;
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
